/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Finance Service
 * Finance Service
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddCartLineItem201,
  AddCartPaymentLine201,
  CreateDripCocktail200,
  CreateDripIngredient200,
  CreateProduct200,
  DeleteCartLineItem200,
  DeleteCartPaymentLine200,
  DeletePaymentMethod200,
  DisableCustomerSubscription200,
  DownloadFile200Two,
  Get200,
  GetAvailableItems200,
  GetCalculatedCocktailPrice200,
  GetCalculatedCocktailPriceParams,
  GetCreditExpireReasons200,
  GetCreditExtendReasons200,
  GetCreditTypes200,
  GetCreditTypesParams,
  GetCustomerAccountBalance200,
  GetCustomerAccountBalanceParams,
  GetCustomerCreditSummary200,
  GetCustomerCreditSummaryParams,
  GetCustomerCreditsUsed200,
  GetCustomerCreditsUsedParams,
  GetDisputeById200,
  GetDisputeStatusForPurchase200,
  GetDisputeStatusForPurchaseParams,
  GetDisputes200,
  GetDisputesParams,
  GetDripCocktailIngredients200,
  GetDripCocktails200,
  GetDripIngredients200,
  GetGiftCard200,
  GetGiftCardParams,
  GetItemPricesByCategory200,
  GetItemPricesByCategoryParams,
  GetManualDiscountReasons200,
  GetParams,
  GetPaymentMethods200,
  GetPaymentMethodsParams,
  GetPendingTicketsForStore200,
  GetPendingTicketsForStoreParams,
  GetPrices200,
  GetProduct200,
  GetProductAvailability200,
  GetProductUsableCredits200,
  GetPromoCodesForStore200,
  GetPurchasableItems200,
  GetPurchasableItemsParams,
  GetPurchaseCategories200,
  GetPurchaseCategoriesParams,
  GetPurchases200,
  GetPurchasesParams,
  GetStudioAvailableItems200,
  ResetDisputeEvidence200,
  SetPrices200,
  StaffCreateCartLineItemRequest,
  StaffCreateCartPaymentLineRequest,
  StaffCreateCreditsRequest,
  StaffCreateDripCocktailRequest,
  StaffCreateDripIngredientRequest,
  StaffCreateProductRequest,
  StaffDeleteCartLineItemRequest,
  StaffDeleteCartPaymentLineRequest,
  StaffGrantCredits200,
  StaffSetItemPricesBody,
  StaffUpdateCartLineItemRequest,
  StaffUpdateCartPaymentLineRequest,
  StaffUpdateCredits200,
  StaffUpdateCreditsRequest,
  StaffUpdateDripCocktailIngredientsRequest,
  StaffUpdateDripIngredientRequest,
  StaffUpdateLineItemRequest,
  StaffUpdateProductAvailabilityRequest,
  StaffUpdateProductRequest,
  StaffUpdateProductUsableCreditsRequest,
  SubmitDispute200,
  SubmitDisputeRequest,
  UpdateCartLineItem200,
  UpdateCartPaymentLine200,
  UpdateDripCocktail200,
  UpdateDripCocktailIngredients200,
  UpdateDripCocktailRequest,
  UpdateDripIngredient200,
  UpdateLineItem200,
  UpdatePrimaryPaymentMethod200,
  UpdateProduct200,
  UpdateProductAvailability200,
  UpdateProductUsableCredits200,
  UploadDisputeEvidence200,
  UploadDisputeProofRequest
} from './finance-api.schemas';

import { financeApiInstance } from '../../common/axios/orvalMutator';
import type { ErrorType, BodyType } from '../../common/axios/orvalMutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getItemPricesByCategory = (
  params?: GetItemPricesByCategoryParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetItemPricesByCategory200>(
    { url: `/staff/item-prices/category`, method: 'GET', params },
    options
  );
};

export const getGetItemPricesByCategoryQueryKey = (
  params?: GetItemPricesByCategoryParams
) => {
  return [`/staff/item-prices/category`, ...(params ? [params] : [])] as const;
};

export const getGetItemPricesByCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getItemPricesByCategory>>,
  TError = ErrorType<unknown>
>(
  params?: GetItemPricesByCategoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getItemPricesByCategory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetItemPricesByCategoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getItemPricesByCategory>>
  > = () => getItemPricesByCategory(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getItemPricesByCategory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetItemPricesByCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getItemPricesByCategory>>
>;
export type GetItemPricesByCategoryQueryError = ErrorType<unknown>;

export function useGetItemPricesByCategory<
  TData = Awaited<ReturnType<typeof getItemPricesByCategory>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetItemPricesByCategoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getItemPricesByCategory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getItemPricesByCategory>>,
          TError,
          Awaited<ReturnType<typeof getItemPricesByCategory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetItemPricesByCategory<
  TData = Awaited<ReturnType<typeof getItemPricesByCategory>>,
  TError = ErrorType<unknown>
>(
  params?: GetItemPricesByCategoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getItemPricesByCategory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getItemPricesByCategory>>,
          TError,
          Awaited<ReturnType<typeof getItemPricesByCategory>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetItemPricesByCategory<
  TData = Awaited<ReturnType<typeof getItemPricesByCategory>>,
  TError = ErrorType<unknown>
>(
  params?: GetItemPricesByCategoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getItemPricesByCategory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetItemPricesByCategory<
  TData = Awaited<ReturnType<typeof getItemPricesByCategory>>,
  TError = ErrorType<unknown>
>(
  params?: GetItemPricesByCategoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getItemPricesByCategory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetItemPricesByCategoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCustomerAccountBalance = (
  params: GetCustomerAccountBalanceParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetCustomerAccountBalance200>(
    { url: `/staff/customer-account-balance`, method: 'GET', params },
    options
  );
};

export const getGetCustomerAccountBalanceQueryKey = (
  params?: GetCustomerAccountBalanceParams
) => {
  return [
    `/staff/customer-account-balance`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCustomerAccountBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAccountBalance>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerAccountBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAccountBalance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerAccountBalanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerAccountBalance>>
  > = () => getCustomerAccountBalance(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAccountBalance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomerAccountBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAccountBalance>>
>;
export type GetCustomerAccountBalanceQueryError = ErrorType<unknown>;

export function useGetCustomerAccountBalance<
  TData = Awaited<ReturnType<typeof getCustomerAccountBalance>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerAccountBalanceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAccountBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccountBalance>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerAccountBalance<
  TData = Awaited<ReturnType<typeof getCustomerAccountBalance>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerAccountBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAccountBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerAccountBalance>>,
          TError,
          Awaited<ReturnType<typeof getCustomerAccountBalance>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerAccountBalance<
  TData = Awaited<ReturnType<typeof getCustomerAccountBalance>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerAccountBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAccountBalance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCustomerAccountBalance<
  TData = Awaited<ReturnType<typeof getCustomerAccountBalance>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerAccountBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerAccountBalance>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomerAccountBalanceQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateDripIngredient = (
  staffUpdateDripIngredientRequest: BodyType<StaffUpdateDripIngredientRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateDripIngredient200>(
    {
      url: `/staff/drip-ingredients`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateDripIngredientRequest
    },
    options
  );
};

export const getUpdateDripIngredientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDripIngredient>>,
    TError,
    { data: BodyType<StaffUpdateDripIngredientRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDripIngredient>>,
  TError,
  { data: BodyType<StaffUpdateDripIngredientRequest> },
  TContext
> => {
  const mutationKey = ['updateDripIngredient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDripIngredient>>,
    { data: BodyType<StaffUpdateDripIngredientRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateDripIngredient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDripIngredientMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDripIngredient>>
>;
export type UpdateDripIngredientMutationBody =
  BodyType<StaffUpdateDripIngredientRequest>;
export type UpdateDripIngredientMutationError = ErrorType<unknown>;

export const useUpdateDripIngredient = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDripIngredient>>,
      TError,
      { data: BodyType<StaffUpdateDripIngredientRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDripIngredient>>,
  TError,
  { data: BodyType<StaffUpdateDripIngredientRequest> },
  TContext
> => {
  const mutationOptions = getUpdateDripIngredientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const createDripIngredient = (
  staffCreateDripIngredientRequest: BodyType<StaffCreateDripIngredientRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<CreateDripIngredient200>(
    {
      url: `/staff/drip-ingredients`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateDripIngredientRequest
    },
    options
  );
};

export const getCreateDripIngredientMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDripIngredient>>,
    TError,
    { data: BodyType<StaffCreateDripIngredientRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDripIngredient>>,
  TError,
  { data: BodyType<StaffCreateDripIngredientRequest> },
  TContext
> => {
  const mutationKey = ['createDripIngredient'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDripIngredient>>,
    { data: BodyType<StaffCreateDripIngredientRequest> }
  > = props => {
    const { data } = props ?? {};

    return createDripIngredient(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDripIngredientMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDripIngredient>>
>;
export type CreateDripIngredientMutationBody =
  BodyType<StaffCreateDripIngredientRequest>;
export type CreateDripIngredientMutationError = ErrorType<unknown>;

export const useCreateDripIngredient = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDripIngredient>>,
      TError,
      { data: BodyType<StaffCreateDripIngredientRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDripIngredient>>,
  TError,
  { data: BodyType<StaffCreateDripIngredientRequest> },
  TContext
> => {
  const mutationOptions = getCreateDripIngredientMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getDripIngredients = (
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetDripIngredients200>(
    { url: `/staff/drip-ingredients`, method: 'GET' },
    options
  );
};

export const getGetDripIngredientsQueryKey = () => {
  return [`/staff/drip-ingredients`] as const;
};

export const getGetDripIngredientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDripIngredients>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getDripIngredients>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDripIngredientsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDripIngredients>>
  > = () => getDripIngredients(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDripIngredients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDripIngredientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDripIngredients>>
>;
export type GetDripIngredientsQueryError = ErrorType<unknown>;

export function useGetDripIngredients<
  TData = Awaited<ReturnType<typeof getDripIngredients>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripIngredients>>,
          TError,
          Awaited<ReturnType<typeof getDripIngredients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripIngredients<
  TData = Awaited<ReturnType<typeof getDripIngredients>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripIngredients>>,
          TError,
          Awaited<ReturnType<typeof getDripIngredients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripIngredients<
  TData = Awaited<ReturnType<typeof getDripIngredients>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDripIngredients<
  TData = Awaited<ReturnType<typeof getDripIngredients>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDripIngredientsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDripCocktails = (
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetDripCocktails200>(
    { url: `/staff/drip-cocktails`, method: 'GET' },
    options
  );
};

export const getGetDripCocktailsQueryKey = () => {
  return [`/staff/drip-cocktails`] as const;
};

export const getGetDripCocktailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDripCocktails>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getDripCocktails>>, TError, TData>
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDripCocktailsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDripCocktails>>
  > = () => getDripCocktails(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDripCocktails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDripCocktailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDripCocktails>>
>;
export type GetDripCocktailsQueryError = ErrorType<unknown>;

export function useGetDripCocktails<
  TData = Awaited<ReturnType<typeof getDripCocktails>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripCocktails>>,
          TError,
          Awaited<ReturnType<typeof getDripCocktails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripCocktails<
  TData = Awaited<ReturnType<typeof getDripCocktails>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripCocktails>>,
          TError,
          Awaited<ReturnType<typeof getDripCocktails>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripCocktails<
  TData = Awaited<ReturnType<typeof getDripCocktails>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDripCocktails<
  TData = Awaited<ReturnType<typeof getDripCocktails>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDripCocktailsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createDripCocktail = (
  staffCreateDripCocktailRequest: BodyType<StaffCreateDripCocktailRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<CreateDripCocktail200>(
    {
      url: `/staff/drip-cocktail`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateDripCocktailRequest
    },
    options
  );
};

export const getCreateDripCocktailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDripCocktail>>,
    TError,
    { data: BodyType<StaffCreateDripCocktailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDripCocktail>>,
  TError,
  { data: BodyType<StaffCreateDripCocktailRequest> },
  TContext
> => {
  const mutationKey = ['createDripCocktail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDripCocktail>>,
    { data: BodyType<StaffCreateDripCocktailRequest> }
  > = props => {
    const { data } = props ?? {};

    return createDripCocktail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDripCocktailMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDripCocktail>>
>;
export type CreateDripCocktailMutationBody =
  BodyType<StaffCreateDripCocktailRequest>;
export type CreateDripCocktailMutationError = ErrorType<unknown>;

export const useCreateDripCocktail = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDripCocktail>>,
      TError,
      { data: BodyType<StaffCreateDripCocktailRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createDripCocktail>>,
  TError,
  { data: BodyType<StaffCreateDripCocktailRequest> },
  TContext
> => {
  const mutationOptions = getCreateDripCocktailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateDripCocktail = (
  updateDripCocktailRequest: BodyType<UpdateDripCocktailRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateDripCocktail200>(
    {
      url: `/staff/drip-cocktail`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateDripCocktailRequest
    },
    options
  );
};

export const getUpdateDripCocktailMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDripCocktail>>,
    TError,
    { data: BodyType<UpdateDripCocktailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDripCocktail>>,
  TError,
  { data: BodyType<UpdateDripCocktailRequest> },
  TContext
> => {
  const mutationKey = ['updateDripCocktail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDripCocktail>>,
    { data: BodyType<UpdateDripCocktailRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateDripCocktail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDripCocktailMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDripCocktail>>
>;
export type UpdateDripCocktailMutationBody =
  BodyType<UpdateDripCocktailRequest>;
export type UpdateDripCocktailMutationError = ErrorType<unknown>;

export const useUpdateDripCocktail = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDripCocktail>>,
      TError,
      { data: BodyType<UpdateDripCocktailRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDripCocktail>>,
  TError,
  { data: BodyType<UpdateDripCocktailRequest> },
  TContext
> => {
  const mutationOptions = getUpdateDripCocktailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getDripCocktailIngredients = (
  purchasableItemId: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetDripCocktailIngredients200>(
    {
      url: `/staff/drip-cocktail-ingredients/${purchasableItemId}`,
      method: 'GET'
    },
    options
  );
};

export const getGetDripCocktailIngredientsQueryKey = (
  purchasableItemId?: number
) => {
  return [`/staff/drip-cocktail-ingredients/${purchasableItemId}`] as const;
};

export const getGetDripCocktailIngredientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDripCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  purchasableItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktailIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDripCocktailIngredientsQueryKey(purchasableItemId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDripCocktailIngredients>>
  > = () => getDripCocktailIngredients(purchasableItemId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!purchasableItemId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDripCocktailIngredients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDripCocktailIngredientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDripCocktailIngredients>>
>;
export type GetDripCocktailIngredientsQueryError = ErrorType<unknown>;

export function useGetDripCocktailIngredients<
  TData = Awaited<ReturnType<typeof getDripCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  purchasableItemId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktailIngredients>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripCocktailIngredients>>,
          TError,
          Awaited<ReturnType<typeof getDripCocktailIngredients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripCocktailIngredients<
  TData = Awaited<ReturnType<typeof getDripCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  purchasableItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktailIngredients>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDripCocktailIngredients>>,
          TError,
          Awaited<ReturnType<typeof getDripCocktailIngredients>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDripCocktailIngredients<
  TData = Awaited<ReturnType<typeof getDripCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  purchasableItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktailIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDripCocktailIngredients<
  TData = Awaited<ReturnType<typeof getDripCocktailIngredients>>,
  TError = ErrorType<unknown>
>(
  purchasableItemId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDripCocktailIngredients>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDripCocktailIngredientsQueryOptions(
    purchasableItemId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateDripCocktailIngredients = (
  staffUpdateDripCocktailIngredientsRequest: BodyType<StaffUpdateDripCocktailIngredientsRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateDripCocktailIngredients200>(
    {
      url: `/staff/drip-cocktail-ingredients`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateDripCocktailIngredientsRequest
    },
    options
  );
};

export const getUpdateDripCocktailIngredientsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDripCocktailIngredients>>,
    TError,
    { data: BodyType<StaffUpdateDripCocktailIngredientsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDripCocktailIngredients>>,
  TError,
  { data: BodyType<StaffUpdateDripCocktailIngredientsRequest> },
  TContext
> => {
  const mutationKey = ['updateDripCocktailIngredients'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDripCocktailIngredients>>,
    { data: BodyType<StaffUpdateDripCocktailIngredientsRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateDripCocktailIngredients(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDripCocktailIngredientsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDripCocktailIngredients>>
>;
export type UpdateDripCocktailIngredientsMutationBody =
  BodyType<StaffUpdateDripCocktailIngredientsRequest>;
export type UpdateDripCocktailIngredientsMutationError = ErrorType<unknown>;

export const useUpdateDripCocktailIngredients = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDripCocktailIngredients>>,
      TError,
      { data: BodyType<StaffUpdateDripCocktailIngredientsRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateDripCocktailIngredients>>,
  TError,
  { data: BodyType<StaffUpdateDripCocktailIngredientsRequest> },
  TContext
> => {
  const mutationOptions =
    getUpdateDripCocktailIngredientsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const disableCustomerSubscription = (
  id: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<DisableCustomerSubscription200>(
    { url: `/staff/customer-subscriptions/${id}/disable`, method: 'PUT' },
    options
  );
};

export const getDisableCustomerSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableCustomerSubscription>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableCustomerSubscription>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['disableCustomerSubscription'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableCustomerSubscription>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return disableCustomerSubscription(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableCustomerSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableCustomerSubscription>>
>;

export type DisableCustomerSubscriptionMutationError = ErrorType<unknown>;

export const useDisableCustomerSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disableCustomerSubscription>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof disableCustomerSubscription>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions =
    getDisableCustomerSubscriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getCustomerCreditSummary = (
  params: GetCustomerCreditSummaryParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetCustomerCreditSummary200>(
    {
      url: `/staff/customer-appointment-credit-summary`,
      method: 'GET',
      params
    },
    options
  );
};

export const getGetCustomerCreditSummaryQueryKey = (
  params?: GetCustomerCreditSummaryParams
) => {
  return [
    `/staff/customer-appointment-credit-summary`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCustomerCreditSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerCreditSummary>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerCreditSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerCreditSummary>>
  > = () => getCustomerCreditSummary(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerCreditSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomerCreditSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerCreditSummary>>
>;
export type GetCustomerCreditSummaryQueryError = ErrorType<unknown>;

export function useGetCustomerCreditSummary<
  TData = Awaited<ReturnType<typeof getCustomerCreditSummary>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditSummary>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerCreditSummary<
  TData = Awaited<ReturnType<typeof getCustomerCreditSummary>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditSummary>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditSummary>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerCreditSummary<
  TData = Awaited<ReturnType<typeof getCustomerCreditSummary>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCustomerCreditSummary<
  TData = Awaited<ReturnType<typeof getCustomerCreditSummary>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomerCreditSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPurchaseCategories = (
  params?: GetPurchaseCategoriesParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetPurchaseCategories200>(
    { url: `/staff/purchase-categories`, method: 'GET', params },
    options
  );
};

export const getGetPurchaseCategoriesQueryKey = (
  params?: GetPurchaseCategoriesParams
) => {
  return [`/staff/purchase-categories`, ...(params ? [params] : [])] as const;
};

export const getGetPurchaseCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchaseCategories>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchaseCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPurchaseCategoriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPurchaseCategories>>
  > = () => getPurchaseCategories(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchaseCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPurchaseCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchaseCategories>>
>;
export type GetPurchaseCategoriesQueryError = ErrorType<unknown>;

export function useGetPurchaseCategories<
  TData = Awaited<ReturnType<typeof getPurchaseCategories>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetPurchaseCategoriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchaseCategories>>,
          TError,
          Awaited<ReturnType<typeof getPurchaseCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchaseCategories<
  TData = Awaited<ReturnType<typeof getPurchaseCategories>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchaseCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchaseCategories>>,
          TError,
          Awaited<ReturnType<typeof getPurchaseCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchaseCategories<
  TData = Awaited<ReturnType<typeof getPurchaseCategories>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchaseCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPurchaseCategories<
  TData = Awaited<ReturnType<typeof getPurchaseCategories>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchaseCategoriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchaseCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPurchaseCategoriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getAvailableItems = (
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetAvailableItems200>(
    { url: `/staff/available-items`, method: 'GET' },
    options
  );
};

export const getGetAvailableItemsQueryKey = () => {
  return [`/staff/available-items`] as const;
};

export const getGetAvailableItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAvailableItems>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAvailableItems>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAvailableItemsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAvailableItems>>
  > = () => getAvailableItems(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAvailableItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAvailableItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAvailableItems>>
>;
export type GetAvailableItemsQueryError = ErrorType<unknown>;

export function useGetAvailableItems<
  TData = Awaited<ReturnType<typeof getAvailableItems>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableItems>>,
          TError,
          Awaited<ReturnType<typeof getAvailableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAvailableItems<
  TData = Awaited<ReturnType<typeof getAvailableItems>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailableItems>>,
          TError,
          Awaited<ReturnType<typeof getAvailableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAvailableItems<
  TData = Awaited<ReturnType<typeof getAvailableItems>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAvailableItems<
  TData = Awaited<ReturnType<typeof getAvailableItems>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAvailableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAvailableItemsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getStudioAvailableItems = (
  studioId: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetStudioAvailableItems200>(
    { url: `/staff/studios/${studioId}/available-items`, method: 'GET' },
    options
  );
};

export const getGetStudioAvailableItemsQueryKey = (studioId?: number) => {
  return [`/staff/studios/${studioId}/available-items`] as const;
};

export const getGetStudioAvailableItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStudioAvailableItems>>,
  TError = ErrorType<unknown>
>(
  studioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudioAvailableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStudioAvailableItemsQueryKey(studioId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStudioAvailableItems>>
  > = () => getStudioAvailableItems(studioId, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!studioId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStudioAvailableItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStudioAvailableItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStudioAvailableItems>>
>;
export type GetStudioAvailableItemsQueryError = ErrorType<unknown>;

export function useGetStudioAvailableItems<
  TData = Awaited<ReturnType<typeof getStudioAvailableItems>>,
  TError = ErrorType<unknown>
>(
  studioId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudioAvailableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudioAvailableItems>>,
          TError,
          Awaited<ReturnType<typeof getStudioAvailableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudioAvailableItems<
  TData = Awaited<ReturnType<typeof getStudioAvailableItems>>,
  TError = ErrorType<unknown>
>(
  studioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudioAvailableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStudioAvailableItems>>,
          TError,
          Awaited<ReturnType<typeof getStudioAvailableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStudioAvailableItems<
  TData = Awaited<ReturnType<typeof getStudioAvailableItems>>,
  TError = ErrorType<unknown>
>(
  studioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudioAvailableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetStudioAvailableItems<
  TData = Awaited<ReturnType<typeof getStudioAvailableItems>>,
  TError = ErrorType<unknown>
>(
  studioId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStudioAvailableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStudioAvailableItemsQueryOptions(
    studioId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGiftCard = (
  params: GetGiftCardParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetGiftCard200>(
    { url: `/staff/gift-card`, method: 'GET', params },
    options
  );
};

export const getGetGiftCardQueryKey = (params?: GetGiftCardParams) => {
  return [`/staff/gift-card`, ...(params ? [params] : [])] as const;
};

export const getGetGiftCardQueryOptions = <
  TData = Awaited<ReturnType<typeof getGiftCard>>,
  TError = ErrorType<unknown>
>(
  params: GetGiftCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftCard>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGiftCardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGiftCard>>> = () =>
    getGiftCard(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGiftCard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGiftCardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGiftCard>>
>;
export type GetGiftCardQueryError = ErrorType<unknown>;

export function useGetGiftCard<
  TData = Awaited<ReturnType<typeof getGiftCard>>,
  TError = ErrorType<unknown>
>(
  params: GetGiftCardParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftCard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftCard>>,
          TError,
          Awaited<ReturnType<typeof getGiftCard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGiftCard<
  TData = Awaited<ReturnType<typeof getGiftCard>>,
  TError = ErrorType<unknown>
>(
  params: GetGiftCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftCard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGiftCard>>,
          TError,
          Awaited<ReturnType<typeof getGiftCard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGiftCard<
  TData = Awaited<ReturnType<typeof getGiftCard>>,
  TError = ErrorType<unknown>
>(
  params: GetGiftCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftCard>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetGiftCard<
  TData = Awaited<ReturnType<typeof getGiftCard>>,
  TError = ErrorType<unknown>
>(
  params: GetGiftCardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getGiftCard>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGiftCardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDisputes = (
  params: GetDisputesParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetDisputes200>(
    { url: `/staff/disputes`, method: 'GET', params },
    options
  );
};

export const getGetDisputesQueryKey = (params?: GetDisputesParams) => {
  return [`/staff/disputes`, ...(params ? [params] : [])] as const;
};

export const getGetDisputesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisputes>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputes>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDisputesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDisputes>>> = () =>
    getDisputes(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisputes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDisputesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisputes>>
>;
export type GetDisputesQueryError = ErrorType<unknown>;

export function useGetDisputes<
  TData = Awaited<ReturnType<typeof getDisputes>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputes>>,
          TError,
          Awaited<ReturnType<typeof getDisputes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDisputes<
  TData = Awaited<ReturnType<typeof getDisputes>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputes>>,
          TError,
          Awaited<ReturnType<typeof getDisputes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDisputes<
  TData = Awaited<ReturnType<typeof getDisputes>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputes>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDisputes<
  TData = Awaited<ReturnType<typeof getDisputes>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputes>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDisputesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDisputeById = (
  id: string,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetDisputeById200>(
    { url: `/staff/disputes/${id}`, method: 'GET' },
    options
  );
};

export const getGetDisputeByIdQueryKey = (id?: string) => {
  return [`/staff/disputes/${id}`] as const;
};

export const getGetDisputeByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisputeById>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputeById>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDisputeByIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisputeById>>
  > = () => getDisputeById(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisputeById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDisputeByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisputeById>>
>;
export type GetDisputeByIdQueryError = ErrorType<unknown>;

export function useGetDisputeById<
  TData = Awaited<ReturnType<typeof getDisputeById>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputeById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputeById>>,
          TError,
          Awaited<ReturnType<typeof getDisputeById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDisputeById<
  TData = Awaited<ReturnType<typeof getDisputeById>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputeById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputeById>>,
          TError,
          Awaited<ReturnType<typeof getDisputeById>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDisputeById<
  TData = Awaited<ReturnType<typeof getDisputeById>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputeById>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDisputeById<
  TData = Awaited<ReturnType<typeof getDisputeById>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDisputeById>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDisputeByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const uploadDisputeEvidence = (
  id: string,
  uploadDisputeProofRequest: BodyType<UploadDisputeProofRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UploadDisputeEvidence200>(
    {
      url: `/staff/disputes/${id}/evidence`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: uploadDisputeProofRequest
    },
    options
  );
};

export const getUploadDisputeEvidenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadDisputeEvidence>>,
    TError,
    { id: string; data: BodyType<UploadDisputeProofRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadDisputeEvidence>>,
  TError,
  { id: string; data: BodyType<UploadDisputeProofRequest> },
  TContext
> => {
  const mutationKey = ['uploadDisputeEvidence'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadDisputeEvidence>>,
    { id: string; data: BodyType<UploadDisputeProofRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return uploadDisputeEvidence(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadDisputeEvidenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadDisputeEvidence>>
>;
export type UploadDisputeEvidenceMutationBody =
  BodyType<UploadDisputeProofRequest>;
export type UploadDisputeEvidenceMutationError = ErrorType<unknown>;

export const useUploadDisputeEvidence = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadDisputeEvidence>>,
      TError,
      { id: string; data: BodyType<UploadDisputeProofRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof uploadDisputeEvidence>>,
  TError,
  { id: string; data: BodyType<UploadDisputeProofRequest> },
  TContext
> => {
  const mutationOptions = getUploadDisputeEvidenceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const submitDispute = (
  id: string,
  submitDisputeRequest: BodyType<SubmitDisputeRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<SubmitDispute200>(
    {
      url: `/staff/disputes/${id}/submit`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: submitDisputeRequest
    },
    options
  );
};

export const getSubmitDisputeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitDispute>>,
    TError,
    { id: string; data: BodyType<SubmitDisputeRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitDispute>>,
  TError,
  { id: string; data: BodyType<SubmitDisputeRequest> },
  TContext
> => {
  const mutationKey = ['submitDispute'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitDispute>>,
    { id: string; data: BodyType<SubmitDisputeRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return submitDispute(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitDisputeMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitDispute>>
>;
export type SubmitDisputeMutationBody = BodyType<SubmitDisputeRequest>;
export type SubmitDisputeMutationError = ErrorType<unknown>;

export const useSubmitDispute = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitDispute>>,
      TError,
      { id: string; data: BodyType<SubmitDisputeRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof submitDispute>>,
  TError,
  { id: string; data: BodyType<SubmitDisputeRequest> },
  TContext
> => {
  const mutationOptions = getSubmitDisputeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const resetDisputeEvidence = (
  id: string,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<ResetDisputeEvidence200>(
    { url: `/staff/disputes/${id}/reset-evidence`, method: 'POST' },
    options
  );
};

export const getResetDisputeEvidenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetDisputeEvidence>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetDisputeEvidence>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['resetDisputeEvidence'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetDisputeEvidence>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return resetDisputeEvidence(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetDisputeEvidenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetDisputeEvidence>>
>;

export type ResetDisputeEvidenceMutationError = ErrorType<unknown>;

export const useResetDisputeEvidence = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetDisputeEvidence>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof resetDisputeEvidence>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getResetDisputeEvidenceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const downloadFile = (
  id: string,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<unknown | DownloadFile200Two>(
    { url: `/staff/files/${id}`, method: 'GET' },
    options
  );
};

export const getDownloadFileQueryKey = (id?: string) => {
  return [`/staff/files/${id}`] as const;
};

export const getDownloadFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadFileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadFile>>> = () =>
    downloadFile(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadFile>>
>;
export type DownloadFileQueryError = ErrorType<unknown>;

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadFile>>,
          TError,
          Awaited<ReturnType<typeof downloadFile>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useDownloadFile<
  TData = Awaited<ReturnType<typeof downloadFile>>,
  TError = ErrorType<unknown>
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getDownloadFileQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDisputeStatusForPurchase = (
  params: GetDisputeStatusForPurchaseParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetDisputeStatusForPurchase200>(
    { url: `/staff/purchase-dispute-status`, method: 'GET', params },
    options
  );
};

export const getGetDisputeStatusForPurchaseQueryKey = (
  params?: GetDisputeStatusForPurchaseParams
) => {
  return [
    `/staff/purchase-dispute-status`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDisputeStatusForPurchaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputeStatusForPurchaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDisputeStatusForPurchaseQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDisputeStatusForPurchase>>
  > = () => getDisputeStatusForPurchase(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDisputeStatusForPurchaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDisputeStatusForPurchase>>
>;
export type GetDisputeStatusForPurchaseQueryError = ErrorType<unknown>;

export function useGetDisputeStatusForPurchase<
  TData = Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputeStatusForPurchaseParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
          TError,
          Awaited<ReturnType<typeof getDisputeStatusForPurchase>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDisputeStatusForPurchase<
  TData = Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputeStatusForPurchaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
          TError,
          Awaited<ReturnType<typeof getDisputeStatusForPurchase>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDisputeStatusForPurchase<
  TData = Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputeStatusForPurchaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetDisputeStatusForPurchase<
  TData = Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
  TError = ErrorType<unknown>
>(
  params: GetDisputeStatusForPurchaseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDisputeStatusForPurchase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDisputeStatusForPurchaseQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPaymentMethods = (
  params: GetPaymentMethodsParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetPaymentMethods200>(
    { url: `/staff/payment-methods`, method: 'GET', params },
    options
  );
};

export const getGetPaymentMethodsQueryKey = (
  params?: GetPaymentMethodsParams
) => {
  return [`/staff/payment-methods`, ...(params ? [params] : [])] as const;
};

export const getGetPaymentMethodsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentMethods>>,
  TError = ErrorType<unknown>
>(
  params: GetPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPaymentMethodsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentMethods>>
  > = () => getPaymentMethods(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentMethods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentMethodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentMethods>>
>;
export type GetPaymentMethodsQueryError = ErrorType<unknown>;

export function useGetPaymentMethods<
  TData = Awaited<ReturnType<typeof getPaymentMethods>>,
  TError = ErrorType<unknown>
>(
  params: GetPaymentMethodsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethods>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethods>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethods<
  TData = Awaited<ReturnType<typeof getPaymentMethods>>,
  TError = ErrorType<unknown>
>(
  params: GetPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethods>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentMethods>>,
          TError,
          Awaited<ReturnType<typeof getPaymentMethods>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentMethods<
  TData = Awaited<ReturnType<typeof getPaymentMethods>>,
  TError = ErrorType<unknown>
>(
  params: GetPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPaymentMethods<
  TData = Awaited<ReturnType<typeof getPaymentMethods>>,
  TError = ErrorType<unknown>
>(
  params: GetPaymentMethodsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentMethods>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPaymentMethodsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deletePaymentMethod = (
  id: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<DeletePaymentMethod200>(
    { url: `/staff/payment-methods/${id}`, method: 'DELETE' },
    options
  );
};

export const getDeletePaymentMethodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePaymentMethod>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePaymentMethod>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deletePaymentMethod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePaymentMethod>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return deletePaymentMethod(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePaymentMethod>>
>;

export type DeletePaymentMethodMutationError = ErrorType<unknown>;

export const useDeletePaymentMethod = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePaymentMethod>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deletePaymentMethod>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeletePaymentMethodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updatePrimaryPaymentMethod = (
  id: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdatePrimaryPaymentMethod200>(
    { url: `/staff/payment-methods/${id}/primary`, method: 'PUT' },
    options
  );
};

export const getUpdatePrimaryPaymentMethodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePrimaryPaymentMethod>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePrimaryPaymentMethod>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['updatePrimaryPaymentMethod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePrimaryPaymentMethod>>,
    { id: number }
  > = props => {
    const { id } = props ?? {};

    return updatePrimaryPaymentMethod(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePrimaryPaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePrimaryPaymentMethod>>
>;

export type UpdatePrimaryPaymentMethodMutationError = ErrorType<unknown>;

export const useUpdatePrimaryPaymentMethod = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePrimaryPaymentMethod>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updatePrimaryPaymentMethod>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getUpdatePrimaryPaymentMethodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const staffGrantCredits = (
  staffCreateCreditsRequest: BodyType<StaffCreateCreditsRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<StaffGrantCredits200>(
    {
      url: `/staff/credits`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateCreditsRequest
    },
    options
  );
};

export const getStaffGrantCreditsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof staffGrantCredits>>,
    TError,
    { data: BodyType<StaffCreateCreditsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof staffGrantCredits>>,
  TError,
  { data: BodyType<StaffCreateCreditsRequest> },
  TContext
> => {
  const mutationKey = ['staffGrantCredits'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof staffGrantCredits>>,
    { data: BodyType<StaffCreateCreditsRequest> }
  > = props => {
    const { data } = props ?? {};

    return staffGrantCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StaffGrantCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof staffGrantCredits>>
>;
export type StaffGrantCreditsMutationBody = BodyType<StaffCreateCreditsRequest>;
export type StaffGrantCreditsMutationError = ErrorType<unknown>;

export const useStaffGrantCredits = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof staffGrantCredits>>,
      TError,
      { data: BodyType<StaffCreateCreditsRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof staffGrantCredits>>,
  TError,
  { data: BodyType<StaffCreateCreditsRequest> },
  TContext
> => {
  const mutationOptions = getStaffGrantCreditsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const staffUpdateCredits = (
  staffUpdateCreditsRequest: BodyType<StaffUpdateCreditsRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<StaffUpdateCredits200>(
    {
      url: `/staff/credits`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateCreditsRequest
    },
    options
  );
};

export const getStaffUpdateCreditsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof staffUpdateCredits>>,
    TError,
    { data: BodyType<StaffUpdateCreditsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof staffUpdateCredits>>,
  TError,
  { data: BodyType<StaffUpdateCreditsRequest> },
  TContext
> => {
  const mutationKey = ['staffUpdateCredits'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof staffUpdateCredits>>,
    { data: BodyType<StaffUpdateCreditsRequest> }
  > = props => {
    const { data } = props ?? {};

    return staffUpdateCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StaffUpdateCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof staffUpdateCredits>>
>;
export type StaffUpdateCreditsMutationBody =
  BodyType<StaffUpdateCreditsRequest>;
export type StaffUpdateCreditsMutationError = ErrorType<unknown>;

export const useStaffUpdateCredits = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof staffUpdateCredits>>,
      TError,
      { data: BodyType<StaffUpdateCreditsRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof staffUpdateCredits>>,
  TError,
  { data: BodyType<StaffUpdateCreditsRequest> },
  TContext
> => {
  const mutationOptions = getStaffUpdateCreditsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getCreditTypes = (
  params?: GetCreditTypesParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetCreditTypes200>(
    { url: `/staff/credit-types`, method: 'GET', params },
    options
  );
};

export const getGetCreditTypesQueryKey = (params?: GetCreditTypesParams) => {
  return [`/staff/credit-types`, ...(params ? [params] : [])] as const;
};

export const getGetCreditTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCreditTypes>>,
  TError = ErrorType<unknown>
>(
  params?: GetCreditTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCreditTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCreditTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCreditTypes>>
  > = () => getCreditTypes(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCreditTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCreditTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCreditTypes>>
>;
export type GetCreditTypesQueryError = ErrorType<unknown>;

export function useGetCreditTypes<
  TData = Awaited<ReturnType<typeof getCreditTypes>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetCreditTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCreditTypes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditTypes>>,
          TError,
          Awaited<ReturnType<typeof getCreditTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditTypes<
  TData = Awaited<ReturnType<typeof getCreditTypes>>,
  TError = ErrorType<unknown>
>(
  params?: GetCreditTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCreditTypes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditTypes>>,
          TError,
          Awaited<ReturnType<typeof getCreditTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditTypes<
  TData = Awaited<ReturnType<typeof getCreditTypes>>,
  TError = ErrorType<unknown>
>(
  params?: GetCreditTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCreditTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCreditTypes<
  TData = Awaited<ReturnType<typeof getCreditTypes>>,
  TError = ErrorType<unknown>
>(
  params?: GetCreditTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCreditTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCreditTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPromoCodesForStore = (
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetPromoCodesForStore200>(
    { url: `/staff/coupon-codes`, method: 'GET' },
    options
  );
};

export const getGetPromoCodesForStoreQueryKey = () => {
  return [`/staff/coupon-codes`] as const;
};

export const getGetPromoCodesForStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getPromoCodesForStore>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getPromoCodesForStore>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPromoCodesForStoreQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPromoCodesForStore>>
  > = () => getPromoCodesForStore(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPromoCodesForStore>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPromoCodesForStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPromoCodesForStore>>
>;
export type GetPromoCodesForStoreQueryError = ErrorType<unknown>;

export function useGetPromoCodesForStore<
  TData = Awaited<ReturnType<typeof getPromoCodesForStore>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPromoCodesForStore>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromoCodesForStore>>,
          TError,
          Awaited<ReturnType<typeof getPromoCodesForStore>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPromoCodesForStore<
  TData = Awaited<ReturnType<typeof getPromoCodesForStore>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPromoCodesForStore>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromoCodesForStore>>,
          TError,
          Awaited<ReturnType<typeof getPromoCodesForStore>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPromoCodesForStore<
  TData = Awaited<ReturnType<typeof getPromoCodesForStore>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPromoCodesForStore>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPromoCodesForStore<
  TData = Awaited<ReturnType<typeof getPromoCodesForStore>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPromoCodesForStore>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPromoCodesForStoreQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const get = (
  params: GetParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<Get200>(
    { url: `/staff/users/coupon-codes`, method: 'GET', params },
    options
  );
};

export const getGetQueryKey = (params?: GetParams) => {
  return [`/staff/users/coupon-codes`, ...(params ? [params] : [])] as const;
};

export const getGetQueryOptions = <
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>
>(
  params: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = () =>
    get(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof get>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetQueryResult = NonNullable<Awaited<ReturnType<typeof get>>>;
export type GetQueryError = ErrorType<unknown>;

export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>
>(
  params: GetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>
>(
  params: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>
>(
  params: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGet<
  TData = Awaited<ReturnType<typeof get>>,
  TError = ErrorType<unknown>
>(
  params: GetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCustomerCreditsUsed = (
  params: GetCustomerCreditsUsedParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetCustomerCreditsUsed200>(
    { url: `/staff/users/credits-used`, method: 'GET', params },
    options
  );
};

export const getGetCustomerCreditsUsedQueryKey = (
  params?: GetCustomerCreditsUsedParams
) => {
  return [`/staff/users/credits-used`, ...(params ? [params] : [])] as const;
};

export const getGetCustomerCreditsUsedQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditsUsedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerCreditsUsedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerCreditsUsed>>
  > = () => getCustomerCreditsUsed(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomerCreditsUsedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerCreditsUsed>>
>;
export type GetCustomerCreditsUsedQueryError = ErrorType<unknown>;

export function useGetCustomerCreditsUsed<
  TData = Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditsUsedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditsUsed>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerCreditsUsed<
  TData = Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditsUsedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
          TError,
          Awaited<ReturnType<typeof getCustomerCreditsUsed>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomerCreditsUsed<
  TData = Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditsUsedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCustomerCreditsUsed<
  TData = Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
  TError = ErrorType<unknown>
>(
  params: GetCustomerCreditsUsedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomerCreditsUsed>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomerCreditsUsedQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const addCartLineItem = (
  staffCreateCartLineItemRequest: BodyType<StaffCreateCartLineItemRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<AddCartLineItem201>(
    {
      url: `/staff/cart-line-items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateCartLineItemRequest
    },
    options
  );
};

export const getAddCartLineItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCartLineItem>>,
    TError,
    { data: BodyType<StaffCreateCartLineItemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addCartLineItem>>,
  TError,
  { data: BodyType<StaffCreateCartLineItemRequest> },
  TContext
> => {
  const mutationKey = ['addCartLineItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addCartLineItem>>,
    { data: BodyType<StaffCreateCartLineItemRequest> }
  > = props => {
    const { data } = props ?? {};

    return addCartLineItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCartLineItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof addCartLineItem>>
>;
export type AddCartLineItemMutationBody =
  BodyType<StaffCreateCartLineItemRequest>;
export type AddCartLineItemMutationError = ErrorType<unknown>;

export const useAddCartLineItem = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addCartLineItem>>,
      TError,
      { data: BodyType<StaffCreateCartLineItemRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addCartLineItem>>,
  TError,
  { data: BodyType<StaffCreateCartLineItemRequest> },
  TContext
> => {
  const mutationOptions = getAddCartLineItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteCartLineItem = (
  staffDeleteCartLineItemRequest: BodyType<StaffDeleteCartLineItemRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<DeleteCartLineItem200>(
    {
      url: `/staff/cart-line-items`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: staffDeleteCartLineItemRequest
    },
    options
  );
};

export const getDeleteCartLineItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCartLineItem>>,
    TError,
    { data: BodyType<StaffDeleteCartLineItemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCartLineItem>>,
  TError,
  { data: BodyType<StaffDeleteCartLineItemRequest> },
  TContext
> => {
  const mutationKey = ['deleteCartLineItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCartLineItem>>,
    { data: BodyType<StaffDeleteCartLineItemRequest> }
  > = props => {
    const { data } = props ?? {};

    return deleteCartLineItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCartLineItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCartLineItem>>
>;
export type DeleteCartLineItemMutationBody =
  BodyType<StaffDeleteCartLineItemRequest>;
export type DeleteCartLineItemMutationError = ErrorType<unknown>;

export const useDeleteCartLineItem = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCartLineItem>>,
      TError,
      { data: BodyType<StaffDeleteCartLineItemRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCartLineItem>>,
  TError,
  { data: BodyType<StaffDeleteCartLineItemRequest> },
  TContext
> => {
  const mutationOptions = getDeleteCartLineItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateCartLineItem = (
  staffUpdateCartLineItemRequest: BodyType<StaffUpdateCartLineItemRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateCartLineItem200>(
    {
      url: `/staff/cart-line-items`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateCartLineItemRequest
    },
    options
  );
};

export const getUpdateCartLineItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCartLineItem>>,
    TError,
    { data: BodyType<StaffUpdateCartLineItemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCartLineItem>>,
  TError,
  { data: BodyType<StaffUpdateCartLineItemRequest> },
  TContext
> => {
  const mutationKey = ['updateCartLineItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCartLineItem>>,
    { data: BodyType<StaffUpdateCartLineItemRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateCartLineItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCartLineItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCartLineItem>>
>;
export type UpdateCartLineItemMutationBody =
  BodyType<StaffUpdateCartLineItemRequest>;
export type UpdateCartLineItemMutationError = ErrorType<unknown>;

export const useUpdateCartLineItem = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCartLineItem>>,
      TError,
      { data: BodyType<StaffUpdateCartLineItemRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateCartLineItem>>,
  TError,
  { data: BodyType<StaffUpdateCartLineItemRequest> },
  TContext
> => {
  const mutationOptions = getUpdateCartLineItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const addCartPaymentLine = (
  staffCreateCartPaymentLineRequest: BodyType<StaffCreateCartPaymentLineRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<AddCartPaymentLine201>(
    {
      url: `/staff/cart-payment-lines`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateCartPaymentLineRequest
    },
    options
  );
};

export const getAddCartPaymentLineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCartPaymentLine>>,
    TError,
    { data: BodyType<StaffCreateCartPaymentLineRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addCartPaymentLine>>,
  TError,
  { data: BodyType<StaffCreateCartPaymentLineRequest> },
  TContext
> => {
  const mutationKey = ['addCartPaymentLine'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addCartPaymentLine>>,
    { data: BodyType<StaffCreateCartPaymentLineRequest> }
  > = props => {
    const { data } = props ?? {};

    return addCartPaymentLine(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCartPaymentLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof addCartPaymentLine>>
>;
export type AddCartPaymentLineMutationBody =
  BodyType<StaffCreateCartPaymentLineRequest>;
export type AddCartPaymentLineMutationError = ErrorType<unknown>;

export const useAddCartPaymentLine = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addCartPaymentLine>>,
      TError,
      { data: BodyType<StaffCreateCartPaymentLineRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addCartPaymentLine>>,
  TError,
  { data: BodyType<StaffCreateCartPaymentLineRequest> },
  TContext
> => {
  const mutationOptions = getAddCartPaymentLineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const deleteCartPaymentLine = (
  staffDeleteCartPaymentLineRequest: BodyType<StaffDeleteCartPaymentLineRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<DeleteCartPaymentLine200>(
    {
      url: `/staff/cart-payment-lines`,
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      data: staffDeleteCartPaymentLineRequest
    },
    options
  );
};

export const getDeleteCartPaymentLineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCartPaymentLine>>,
    TError,
    { data: BodyType<StaffDeleteCartPaymentLineRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCartPaymentLine>>,
  TError,
  { data: BodyType<StaffDeleteCartPaymentLineRequest> },
  TContext
> => {
  const mutationKey = ['deleteCartPaymentLine'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCartPaymentLine>>,
    { data: BodyType<StaffDeleteCartPaymentLineRequest> }
  > = props => {
    const { data } = props ?? {};

    return deleteCartPaymentLine(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCartPaymentLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCartPaymentLine>>
>;
export type DeleteCartPaymentLineMutationBody =
  BodyType<StaffDeleteCartPaymentLineRequest>;
export type DeleteCartPaymentLineMutationError = ErrorType<unknown>;

export const useDeleteCartPaymentLine = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCartPaymentLine>>,
      TError,
      { data: BodyType<StaffDeleteCartPaymentLineRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCartPaymentLine>>,
  TError,
  { data: BodyType<StaffDeleteCartPaymentLineRequest> },
  TContext
> => {
  const mutationOptions = getDeleteCartPaymentLineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const updateCartPaymentLine = (
  staffUpdateCartPaymentLineRequest: BodyType<StaffUpdateCartPaymentLineRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateCartPaymentLine200>(
    {
      url: `/staff/cart-payment-lines`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateCartPaymentLineRequest
    },
    options
  );
};

export const getUpdateCartPaymentLineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCartPaymentLine>>,
    TError,
    { data: BodyType<StaffUpdateCartPaymentLineRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCartPaymentLine>>,
  TError,
  { data: BodyType<StaffUpdateCartPaymentLineRequest> },
  TContext
> => {
  const mutationKey = ['updateCartPaymentLine'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCartPaymentLine>>,
    { data: BodyType<StaffUpdateCartPaymentLineRequest> }
  > = props => {
    const { data } = props ?? {};

    return updateCartPaymentLine(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCartPaymentLineMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCartPaymentLine>>
>;
export type UpdateCartPaymentLineMutationBody =
  BodyType<StaffUpdateCartPaymentLineRequest>;
export type UpdateCartPaymentLineMutationError = ErrorType<unknown>;

export const useUpdateCartPaymentLine = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCartPaymentLine>>,
      TError,
      { data: BodyType<StaffUpdateCartPaymentLineRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateCartPaymentLine>>,
  TError,
  { data: BodyType<StaffUpdateCartPaymentLineRequest> },
  TContext
> => {
  const mutationOptions = getUpdateCartPaymentLineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getCreditExpireReasons = (
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetCreditExpireReasons200>(
    { url: `/staff/credit-expire-reasons`, method: 'GET' },
    options
  );
};

export const getGetCreditExpireReasonsQueryKey = () => {
  return [`/staff/credit-expire-reasons`] as const;
};

export const getGetCreditExpireReasonsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCreditExpireReasons>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCreditExpireReasons>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCreditExpireReasonsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCreditExpireReasons>>
  > = () => getCreditExpireReasons(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCreditExpireReasons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCreditExpireReasonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCreditExpireReasons>>
>;
export type GetCreditExpireReasonsQueryError = ErrorType<unknown>;

export function useGetCreditExpireReasons<
  TData = Awaited<ReturnType<typeof getCreditExpireReasons>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExpireReasons>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditExpireReasons>>,
          TError,
          Awaited<ReturnType<typeof getCreditExpireReasons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditExpireReasons<
  TData = Awaited<ReturnType<typeof getCreditExpireReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExpireReasons>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditExpireReasons>>,
          TError,
          Awaited<ReturnType<typeof getCreditExpireReasons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditExpireReasons<
  TData = Awaited<ReturnType<typeof getCreditExpireReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExpireReasons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCreditExpireReasons<
  TData = Awaited<ReturnType<typeof getCreditExpireReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExpireReasons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCreditExpireReasonsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCreditExtendReasons = (
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetCreditExtendReasons200>(
    { url: `/staff/credit-extend-reasons`, method: 'GET' },
    options
  );
};

export const getGetCreditExtendReasonsQueryKey = () => {
  return [`/staff/credit-extend-reasons`] as const;
};

export const getGetCreditExtendReasonsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCreditExtendReasons>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCreditExtendReasons>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCreditExtendReasonsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCreditExtendReasons>>
  > = () => getCreditExtendReasons(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCreditExtendReasons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCreditExtendReasonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCreditExtendReasons>>
>;
export type GetCreditExtendReasonsQueryError = ErrorType<unknown>;

export function useGetCreditExtendReasons<
  TData = Awaited<ReturnType<typeof getCreditExtendReasons>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExtendReasons>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditExtendReasons>>,
          TError,
          Awaited<ReturnType<typeof getCreditExtendReasons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditExtendReasons<
  TData = Awaited<ReturnType<typeof getCreditExtendReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExtendReasons>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreditExtendReasons>>,
          TError,
          Awaited<ReturnType<typeof getCreditExtendReasons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCreditExtendReasons<
  TData = Awaited<ReturnType<typeof getCreditExtendReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExtendReasons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCreditExtendReasons<
  TData = Awaited<ReturnType<typeof getCreditExtendReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCreditExtendReasons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCreditExtendReasonsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getManualDiscountReasons = (
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetManualDiscountReasons200>(
    { url: `/staff/manual-discount-reasons`, method: 'GET' },
    options
  );
};

export const getGetManualDiscountReasonsQueryKey = () => {
  return [`/staff/manual-discount-reasons`] as const;
};

export const getGetManualDiscountReasonsQueryOptions = <
  TData = Awaited<ReturnType<typeof getManualDiscountReasons>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getManualDiscountReasons>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetManualDiscountReasonsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getManualDiscountReasons>>
  > = () => getManualDiscountReasons(requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getManualDiscountReasons>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetManualDiscountReasonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getManualDiscountReasons>>
>;
export type GetManualDiscountReasonsQueryError = ErrorType<unknown>;

export function useGetManualDiscountReasons<
  TData = Awaited<ReturnType<typeof getManualDiscountReasons>>,
  TError = ErrorType<unknown>
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getManualDiscountReasons>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManualDiscountReasons>>,
          TError,
          Awaited<ReturnType<typeof getManualDiscountReasons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetManualDiscountReasons<
  TData = Awaited<ReturnType<typeof getManualDiscountReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getManualDiscountReasons>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getManualDiscountReasons>>,
          TError,
          Awaited<ReturnType<typeof getManualDiscountReasons>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetManualDiscountReasons<
  TData = Awaited<ReturnType<typeof getManualDiscountReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getManualDiscountReasons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetManualDiscountReasons<
  TData = Awaited<ReturnType<typeof getManualDiscountReasons>>,
  TError = ErrorType<unknown>
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getManualDiscountReasons>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetManualDiscountReasonsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPurchasableItems = (
  params?: GetPurchasableItemsParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetPurchasableItems200>(
    { url: `/staff/purchasable-items`, method: 'GET', params },
    options
  );
};

export const getGetPurchasableItemsQueryKey = (
  params?: GetPurchasableItemsParams
) => {
  return [`/staff/purchasable-items`, ...(params ? [params] : [])] as const;
};

export const getGetPurchasableItemsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchasableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPurchasableItemsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPurchasableItems>>
  > = () => getPurchasableItems(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchasableItems>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPurchasableItemsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchasableItems>>
>;
export type GetPurchasableItemsQueryError = ErrorType<unknown>;

export function useGetPurchasableItems<
  TData = Awaited<ReturnType<typeof getPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetPurchasableItemsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchasableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchasableItems>>,
          TError,
          Awaited<ReturnType<typeof getPurchasableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchasableItems<
  TData = Awaited<ReturnType<typeof getPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchasableItems>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchasableItems>>,
          TError,
          Awaited<ReturnType<typeof getPurchasableItems>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchasableItems<
  TData = Awaited<ReturnType<typeof getPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchasableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPurchasableItems<
  TData = Awaited<ReturnType<typeof getPurchasableItems>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasableItemsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPurchasableItems>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPurchasableItemsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getCalculatedCocktailPrice = (
  params: GetCalculatedCocktailPriceParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetCalculatedCocktailPrice200>(
    { url: `/staff/calculated-cocktail-price`, method: 'GET', params },
    options
  );
};

export const getGetCalculatedCocktailPriceQueryKey = (
  params?: GetCalculatedCocktailPriceParams
) => {
  return [
    `/staff/calculated-cocktail-price`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetCalculatedCocktailPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
  TError = ErrorType<unknown>
>(
  params: GetCalculatedCocktailPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCalculatedCocktailPriceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCalculatedCocktailPrice>>
  > = () => getCalculatedCocktailPrice(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalculatedCocktailPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCalculatedCocktailPrice>>
>;
export type GetCalculatedCocktailPriceQueryError = ErrorType<unknown>;

export function useGetCalculatedCocktailPrice<
  TData = Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
  TError = ErrorType<unknown>
>(
  params: GetCalculatedCocktailPriceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
          TError,
          Awaited<ReturnType<typeof getCalculatedCocktailPrice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalculatedCocktailPrice<
  TData = Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
  TError = ErrorType<unknown>
>(
  params: GetCalculatedCocktailPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
          TError,
          Awaited<ReturnType<typeof getCalculatedCocktailPrice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalculatedCocktailPrice<
  TData = Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
  TError = ErrorType<unknown>
>(
  params: GetCalculatedCocktailPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetCalculatedCocktailPrice<
  TData = Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
  TError = ErrorType<unknown>
>(
  params: GetCalculatedCocktailPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCalculatedCocktailPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCalculatedCocktailPriceQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getPrices = (
  id: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetPrices200>(
    { url: `/staff/item-prices/${id}`, method: 'GET' },
    options
  );
};

export const getGetPricesQueryKey = (id?: number) => {
  return [`/staff/item-prices/${id}`] as const;
};

export const getGetPricesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPrices>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPricesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrices>>> = () =>
    getPrices(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getPrices>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetPricesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrices>>
>;
export type GetPricesQueryError = ErrorType<unknown>;

export function useGetPrices<
  TData = Awaited<ReturnType<typeof getPrices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPrices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrices>>,
          TError,
          Awaited<ReturnType<typeof getPrices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrices<
  TData = Awaited<ReturnType<typeof getPrices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPrices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPrices>>,
          TError,
          Awaited<ReturnType<typeof getPrices>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPrices<
  TData = Awaited<ReturnType<typeof getPrices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPrices>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetPrices<
  TData = Awaited<ReturnType<typeof getPrices>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPrices>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPricesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const setPrices = (
  id: number,
  staffSetItemPricesBody: BodyType<StaffSetItemPricesBody>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<SetPrices200>(
    {
      url: `/staff/item-prices/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffSetItemPricesBody
    },
    options
  );
};

export const getSetPricesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setPrices>>,
    TError,
    { id: number; data: BodyType<StaffSetItemPricesBody> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setPrices>>,
  TError,
  { id: number; data: BodyType<StaffSetItemPricesBody> },
  TContext
> => {
  const mutationKey = ['setPrices'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setPrices>>,
    { id: number; data: BodyType<StaffSetItemPricesBody> }
  > = props => {
    const { id, data } = props ?? {};

    return setPrices(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetPricesMutationResult = NonNullable<
  Awaited<ReturnType<typeof setPrices>>
>;
export type SetPricesMutationBody = BodyType<StaffSetItemPricesBody>;
export type SetPricesMutationError = ErrorType<unknown>;

export const useSetPrices = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setPrices>>,
      TError,
      { id: number; data: BodyType<StaffSetItemPricesBody> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setPrices>>,
  TError,
  { id: number; data: BodyType<StaffSetItemPricesBody> },
  TContext
> => {
  const mutationOptions = getSetPricesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get pending tickets for store
 * @summary Get pending tickets for store
 */
export const getPendingTicketsForStore = (
  params?: GetPendingTicketsForStoreParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetPendingTicketsForStore200>(
    { url: `/staff/pending-tickets`, method: 'GET', params },
    options
  );
};

export const getGetPendingTicketsForStoreQueryKey = (
  params?: GetPendingTicketsForStoreParams
) => {
  return [`/staff/pending-tickets`, ...(params ? [params] : [])] as const;
};

export const getGetPendingTicketsForStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getPendingTicketsForStore>>,
  TError = ErrorType<unknown>
>(
  params?: GetPendingTicketsForStoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingTicketsForStore>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPendingTicketsForStoreQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPendingTicketsForStore>>
  > = () => getPendingTicketsForStore(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPendingTicketsForStore>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPendingTicketsForStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPendingTicketsForStore>>
>;
export type GetPendingTicketsForStoreQueryError = ErrorType<unknown>;

export function useGetPendingTicketsForStore<
  TData = Awaited<ReturnType<typeof getPendingTicketsForStore>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetPendingTicketsForStoreParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingTicketsForStore>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingTicketsForStore>>,
          TError,
          Awaited<ReturnType<typeof getPendingTicketsForStore>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingTicketsForStore<
  TData = Awaited<ReturnType<typeof getPendingTicketsForStore>>,
  TError = ErrorType<unknown>
>(
  params?: GetPendingTicketsForStoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingTicketsForStore>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingTicketsForStore>>,
          TError,
          Awaited<ReturnType<typeof getPendingTicketsForStore>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPendingTicketsForStore<
  TData = Awaited<ReturnType<typeof getPendingTicketsForStore>>,
  TError = ErrorType<unknown>
>(
  params?: GetPendingTicketsForStoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingTicketsForStore>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get pending tickets for store
 */

export function useGetPendingTicketsForStore<
  TData = Awaited<ReturnType<typeof getPendingTicketsForStore>>,
  TError = ErrorType<unknown>
>(
  params?: GetPendingTicketsForStoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPendingTicketsForStore>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPendingTicketsForStoreQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get past purchases for store
 * @summary Get past purchases for store
 */
export const getPurchases = (
  params?: GetPurchasesParams,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetPurchases200>(
    { url: `/staff/purchases`, method: 'GET', params },
    options
  );
};

export const getGetPurchasesQueryKey = (params?: GetPurchasesParams) => {
  return [`/staff/purchases`, ...(params ? [params] : [])] as const;
};

export const getGetPurchasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchases>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPurchases>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPurchasesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPurchases>>> = () =>
    getPurchases(params, requestOptions);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPurchasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchases>>
>;
export type GetPurchasesQueryError = ErrorType<unknown>;

export function useGetPurchases<
  TData = Awaited<ReturnType<typeof getPurchases>>,
  TError = ErrorType<unknown>
>(
  params: undefined | GetPurchasesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPurchases>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchases>>,
          TError,
          Awaited<ReturnType<typeof getPurchases>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchases<
  TData = Awaited<ReturnType<typeof getPurchases>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPurchases>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPurchases>>,
          TError,
          Awaited<ReturnType<typeof getPurchases>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPurchases<
  TData = Awaited<ReturnType<typeof getPurchases>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPurchases>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get past purchases for store
 */

export function useGetPurchases<
  TData = Awaited<ReturnType<typeof getPurchases>>,
  TError = ErrorType<unknown>
>(
  params?: GetPurchasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPurchases>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPurchasesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateLineItem = (
  id: number,
  staffUpdateLineItemRequest: BodyType<StaffUpdateLineItemRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateLineItem200>(
    {
      url: `/staff/purchase-line-item/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateLineItemRequest
    },
    options
  );
};

export const getUpdateLineItemMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLineItem>>,
    TError,
    { id: number; data: BodyType<StaffUpdateLineItemRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLineItem>>,
  TError,
  { id: number; data: BodyType<StaffUpdateLineItemRequest> },
  TContext
> => {
  const mutationKey = ['updateLineItem'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLineItem>>,
    { id: number; data: BodyType<StaffUpdateLineItemRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return updateLineItem(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLineItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLineItem>>
>;
export type UpdateLineItemMutationBody = BodyType<StaffUpdateLineItemRequest>;
export type UpdateLineItemMutationError = ErrorType<unknown>;

export const useUpdateLineItem = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateLineItem>>,
      TError,
      { id: number; data: BodyType<StaffUpdateLineItemRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateLineItem>>,
  TError,
  { id: number; data: BodyType<StaffUpdateLineItemRequest> },
  TContext
> => {
  const mutationOptions = getUpdateLineItemMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getProduct = (
  id: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetProduct200>(
    { url: `/staff/product/${id}`, method: 'GET' },
    options
  );
};

export const getGetProductQueryKey = (id?: number) => {
  return [`/staff/product/${id}`] as const;
};

export const getGetProductQueryOptions = <
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = () =>
    getProduct(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProduct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProduct>>
>;
export type GetProductQueryError = ErrorType<unknown>;

export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetProduct<
  TData = Awaited<ReturnType<typeof getProduct>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateProduct = (
  id: number,
  staffUpdateProductRequest: BodyType<StaffUpdateProductRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateProduct200>(
    {
      url: `/staff/product/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateProductRequest
    },
    options
  );
};

export const getUpdateProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProduct>>,
    TError,
    { id: number; data: BodyType<StaffUpdateProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: number; data: BodyType<StaffUpdateProductRequest> },
  TContext
> => {
  const mutationKey = ['updateProduct'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProduct>>,
    { id: number; data: BodyType<StaffUpdateProductRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return updateProduct(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProduct>>
>;
export type UpdateProductMutationBody = BodyType<StaffUpdateProductRequest>;
export type UpdateProductMutationError = ErrorType<unknown>;

export const useUpdateProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProduct>>,
      TError,
      { id: number; data: BodyType<StaffUpdateProductRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateProduct>>,
  TError,
  { id: number; data: BodyType<StaffUpdateProductRequest> },
  TContext
> => {
  const mutationOptions = getUpdateProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const createProduct = (
  staffCreateProductRequest: BodyType<StaffCreateProductRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<CreateProduct200>(
    {
      url: `/staff/product`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: staffCreateProductRequest
    },
    options
  );
};

export const getCreateProductMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProduct>>,
    TError,
    { data: BodyType<StaffCreateProductRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<StaffCreateProductRequest> },
  TContext
> => {
  const mutationKey = ['createProduct'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProduct>>,
    { data: BodyType<StaffCreateProductRequest> }
  > = props => {
    const { data } = props ?? {};

    return createProduct(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProductMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProduct>>
>;
export type CreateProductMutationBody = BodyType<StaffCreateProductRequest>;
export type CreateProductMutationError = ErrorType<unknown>;

export const useCreateProduct = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createProduct>>,
      TError,
      { data: BodyType<StaffCreateProductRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createProduct>>,
  TError,
  { data: BodyType<StaffCreateProductRequest> },
  TContext
> => {
  const mutationOptions = getCreateProductMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getProductAvailability = (
  id: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetProductAvailability200>(
    { url: `/staff/product/${id}/availability`, method: 'GET' },
    options
  );
};

export const getGetProductAvailabilityQueryKey = (id?: number) => {
  return [`/staff/product/${id}/availability`] as const;
};

export const getGetProductAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductAvailability>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProductAvailabilityQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProductAvailability>>
  > = () => getProductAvailability(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductAvailability>>
>;
export type GetProductAvailabilityQueryError = ErrorType<unknown>;

export function useGetProductAvailability<
  TData = Awaited<ReturnType<typeof getProductAvailability>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAvailability>>,
          TError,
          Awaited<ReturnType<typeof getProductAvailability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductAvailability<
  TData = Awaited<ReturnType<typeof getProductAvailability>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAvailability>>,
          TError,
          Awaited<ReturnType<typeof getProductAvailability>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductAvailability<
  TData = Awaited<ReturnType<typeof getProductAvailability>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetProductAvailability<
  TData = Awaited<ReturnType<typeof getProductAvailability>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductAvailability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductAvailabilityQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateProductAvailability = (
  id: number,
  staffUpdateProductAvailabilityRequest: BodyType<StaffUpdateProductAvailabilityRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateProductAvailability200>(
    {
      url: `/staff/product/${id}/availability`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateProductAvailabilityRequest
    },
    options
  );
};

export const getUpdateProductAvailabilityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProductAvailability>>,
    TError,
    { id: number; data: BodyType<StaffUpdateProductAvailabilityRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProductAvailability>>,
  TError,
  { id: number; data: BodyType<StaffUpdateProductAvailabilityRequest> },
  TContext
> => {
  const mutationKey = ['updateProductAvailability'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProductAvailability>>,
    { id: number; data: BodyType<StaffUpdateProductAvailabilityRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return updateProductAvailability(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductAvailabilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProductAvailability>>
>;
export type UpdateProductAvailabilityMutationBody =
  BodyType<StaffUpdateProductAvailabilityRequest>;
export type UpdateProductAvailabilityMutationError = ErrorType<unknown>;

export const useUpdateProductAvailability = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProductAvailability>>,
      TError,
      { id: number; data: BodyType<StaffUpdateProductAvailabilityRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateProductAvailability>>,
  TError,
  { id: number; data: BodyType<StaffUpdateProductAvailabilityRequest> },
  TContext
> => {
  const mutationOptions = getUpdateProductAvailabilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getProductUsableCredits = (
  id: number,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<GetProductUsableCredits200>(
    { url: `/staff/product/${id}/usable-credits`, method: 'GET' },
    options
  );
};

export const getGetProductUsableCreditsQueryKey = (id?: number) => {
  return [`/staff/product/${id}/usable-credits`] as const;
};

export const getGetProductUsableCreditsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductUsableCredits>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductUsableCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProductUsableCreditsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProductUsableCredits>>
  > = () => getProductUsableCredits(id, requestOptions);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductUsableCredits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProductUsableCreditsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductUsableCredits>>
>;
export type GetProductUsableCreditsQueryError = ErrorType<unknown>;

export function useGetProductUsableCredits<
  TData = Awaited<ReturnType<typeof getProductUsableCredits>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductUsableCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductUsableCredits>>,
          TError,
          Awaited<ReturnType<typeof getProductUsableCredits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductUsableCredits<
  TData = Awaited<ReturnType<typeof getProductUsableCredits>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductUsableCredits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductUsableCredits>>,
          TError,
          Awaited<ReturnType<typeof getProductUsableCredits>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetProductUsableCredits<
  TData = Awaited<ReturnType<typeof getProductUsableCredits>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductUsableCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetProductUsableCredits<
  TData = Awaited<ReturnType<typeof getProductUsableCredits>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getProductUsableCredits>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetProductUsableCreditsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateProductUsableCredits = (
  id: number,
  staffUpdateProductUsableCreditsRequest: BodyType<StaffUpdateProductUsableCreditsRequest>,
  options?: SecondParameter<typeof financeApiInstance>
) => {
  return financeApiInstance<UpdateProductUsableCredits200>(
    {
      url: `/staff/product/${id}/usable-credits`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: staffUpdateProductUsableCreditsRequest
    },
    options
  );
};

export const getUpdateProductUsableCreditsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProductUsableCredits>>,
    TError,
    { id: number; data: BodyType<StaffUpdateProductUsableCreditsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof financeApiInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProductUsableCredits>>,
  TError,
  { id: number; data: BodyType<StaffUpdateProductUsableCreditsRequest> },
  TContext
> => {
  const mutationKey = ['updateProductUsableCredits'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProductUsableCredits>>,
    { id: number; data: BodyType<StaffUpdateProductUsableCreditsRequest> }
  > = props => {
    const { id, data } = props ?? {};

    return updateProductUsableCredits(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProductUsableCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProductUsableCredits>>
>;
export type UpdateProductUsableCreditsMutationBody =
  BodyType<StaffUpdateProductUsableCreditsRequest>;
export type UpdateProductUsableCreditsMutationError = ErrorType<unknown>;

export const useUpdateProductUsableCredits = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateProductUsableCredits>>,
      TError,
      { id: number; data: BodyType<StaffUpdateProductUsableCreditsRequest> },
      TContext
    >;
    request?: SecondParameter<typeof financeApiInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateProductUsableCredits>>,
  TError,
  { id: number; data: BodyType<StaffUpdateProductUsableCreditsRequest> },
  TContext
> => {
  const mutationOptions = getUpdateProductUsableCreditsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
